module.exports = __webpack_public_path__ + "static/img/9areaA_08.e9d36f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/9areaA_08.png
// module id = 1061
// module chunks = 1